module.exports = "<p>\n  power-storage-setting works!\n</p>\n"